import React from 'react';

import ComingSoon from "../../images/coming-soon.png";

import "./AgendaPane.css";
import {Divider} from "@mui/material";

export default function AgendaPane(props) {

    return (
        <React.Fragment>

            <div
                style={{
                    margin: "auto",
                    textAlign: "center",
                    justifyContent: "center",
                    display: "flex",
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        padding: "30px",
                        maxWidth: "1000px",
                        marginTop: "10px",
                    }}
                >
                    <div className={"default-text-align-center default-font-bold default-font-xxlarge"}>AGENDA</div>
                    <div className={"default-margin-top-small"}>
                        <Divider sx={{bgcolor: "white"}}/>
                    </div>
                    <div className={"default-margin-top-xlarge"}>
                        <div className={"default-font-bold"}>8:30 – 9:00 a.m.</div>
                        <div className={"default-font-bold"}>Registration & Welcome Coffee</div>
                        <div className={"default-margin-top-tiny"}>Check in, grab your badge, and enjoy coffee and light snacks while networking with fellow attendees.</div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>9:00 – 9:15 a.m.</div>
                        <div className={"default-font-bold"}>Kickoff & Welcome</div>
                        <div className={"default-margin-top-tiny"}>Opening remarks and orientation for the day.</div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>9:15 – 10:05 a.m.</div>
                        <div className={"default-font-bold"}>Session I: AI and Lab Automation</div>
                        <div className={"default-margin-top-tiny"}>Exploring how artificial intelligence is reshaping the design of experiments,
                            driving efficiency, precision, and innovation in research practice.
                        </div>
                        <div style={{textAlign: "center"}}>
                            <div style={{margin: "auto", textAlign: "left", maxWidth: "670px"}}>
                                <ul>
                                    <li>John Harman — Purification in Fully Automated Labs (9:15 – 9:40)</li>
                                    <li>Derrick Miyao — Automating Chemistry in the Age of AI in Drug Discovery (9:40 – 10:05)</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>10:05 – 10:20 a.m</div>
                        <div className={"default-font-bold"}>Morning Break</div>
                        <div className={"default-margin-top-tiny"}>Coffee, tea, and light snacks available. Connect
                            with exhibitors in the networking area.
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>10:20 – 11:10 a.m.</div>
                        <div className={"default-font-bold"}>Session II: Omics-Driven Innovation in Drug Discovery</div>
                        <div style={{margin: "auto", textAlign: "left", maxWidth: "670px"}}>
                            <ul>
                                <li>Pieter Dorrestein, PhD — Unlocking the Chemical Universe: Metabolomics Meets Big Data (10:20 – 10:45)</li>
                                <li>Mo Jain, PhD, MD — Next Gen Multi-Omics as an Engine for Drug Discovery and Development (10:45 – 11:10)</li>
                            </ul>
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>11:10 – 11:55 a.m.</div>
                        <div className={"default-font-bold"}>Roundtable Discussion with PACT Summit Speakers</div>
                        <div className={"default-margin-top-tiny"}>Facilitated exchange of ideas and perspectives among attendees and speakers.</div>
                        <div style={{margin: "auto", textAlign: "left", maxWidth: "670px"}}>
                            <ul>
                                <li>Morning raffle winner announced!</li>
                            </ul>
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>11:55 a.m. – 12:55 p.m.</div>
                        <div className={"default-font-bold"}>Networking Lunch</div>
                        <div className={"default-margin-top-tiny"}>Choice of lunch box options. Opportunity to visit vendor
                            tables and build connections with peers.
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>12:55 – 1:45 p.m.</div>
                        <div className={"default-font-bold"}>Session III: Cutting-Edge Techniques in Pharmaceutical Analysis</div>
                        <div style={{margin: "auto", textAlign: "left", maxWidth: "670px"}}>
                            <ul>
                                <li>Scott Stirn — Phase Quantitation Assessment Utilizing Whole-Powder-Pattern Fitting
                                    XRD Analysis of Material in Drug Product (12:55 – 1:20)</li>
                                <li>Yongdong Wang, PhD — Achieving Unique Elemental Composition on Orbitrap
                                    through Dual Resolution Scans (1:20 – 1:45)</li>
                            </ul>
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>1:45 – 2:00 p.m.</div>
                        <div className={"default-font-bold"}>Afternoon Break — “Recharge & Reconnect”</div>
                        <div className={"default-margin-top-tiny"}>
                            Enjoy refreshments and energizing snacks. Take this time to engage with vendors
                            and catch up with fellow attendees before the keynote.
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>2:00 – 2:30 p.m.</div>
                        <div className={"default-font-bold"}>Keynote Address</div>
                        <div style={{margin: "auto", textAlign: "left", maxWidth: "670px"}}>
                            <ul>
                                <li>Scott Mader — Entrepreneurship, Health Tech, and the Start-up Experience</li>
                            </ul>
                        </div>
                    </div>

                    <div className={"default-margin-top-large"}>
                        <div className={"default-font-bold"}>2:30 – 2:40 p.m.</div>
                        <div className={"default-font-bold"}>Closing Reflections & Open Q&A</div>
                        <div className={"default-margin-top-tiny"}>Conference wrap-up and announcement of afternoon raffle winner</div>
                    </div>

                    <div className={"default-margin-top-large"}>

                        <div className={"default-font-bold"}>2:40 – 3:00 p.m.</div>
                        <div className={"default-font-bold"}>Farewell & Adjournment</div>
                        <div className={"default-margin-top-tiny"}>Final opportunity to meet with vendors and network before departure</div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}